import React from 'react';

const ZoomIn = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M9.72266 0.998535H11.3594C11.7935 0.998535 12.2098 1.17097 12.5167 1.47792C12.8237 1.78486 12.9961 2.20117 12.9961 2.63525V4.27197"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26953 0.998535H2.63281C2.19873 0.998535 1.78242 1.17097 1.47548 1.47792C1.16853 1.78486 0.996094 2.20117 0.996094 2.63525V4.27197"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.72266 13.001H11.3594C11.7935 13.001 12.2098 12.8285 12.5167 12.5216C12.8237 12.2146 12.9961 11.7983 12.9961 11.3643V9.72754"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26953 13.001H2.63281C2.19873 13.001 1.78242 12.8285 1.47548 12.5216C1.16853 12.2146 0.996094 11.7983 0.996094 11.3643V9.72754"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ZoomIn;
